import { cn } from "@/lib/cn";
import { DenkerLogo } from "./logo";
import "./denker-thinking-logo.css";

interface DenkerThinkingLogoProps {
  className?: string;
  height?: number;
  testId?: string;
}

export function DenkerThinkingLogo({
  className,
  height = 15,
  testId,
}: DenkerThinkingLogoProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "denker-thinking-logo inline-grid shrink-0 place-items-center",
        className,
      )}
      data-testid={testId}
    >
      <DenkerLogo variant="symbol" color="currentColor" height={height} />
    </span>
  );
}

export type { DenkerThinkingLogoProps };
